import React from "react";
import FilterList from "../../../components/user/workingPart/workingPartFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const WorkingPartListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

WorkingPartListPage.propTypes = {};

export default WorkingPartListPage;
